import { Controller } from "@hotwired/stimulus";
export default class default_1 extends Controller {
    rate(event) {
        if (event && event.target) {
            const element = event.target.closest('span');
            if (element) {
                const rating = element.dataset.starsRating;
                if (rating) {
                    this.starRatingTarget.value = rating;
                    const stars = this.starContainerTarget.querySelectorAll('.star');
                    stars.forEach(function (value) {
                        if (value && value.dataset && value.dataset.starsRating) {
                            const svg = value.querySelector('svg');
                            console.log(svg);
                            if (svg) {
                                if (rating >= value.dataset.starsRating) {
                                    console.log('flip');
                                    svg.classList.add('text-yellow-400');
                                    svg.classList.remove('text-gray-300');
                                }
                                else {
                                    console.log('clip');
                                    svg.classList.remove('text-yellow-400');
                                    svg.classList.add('text-gray-300');
                                }
                            }
                        }
                    });
                }
            }
        }
    }
}
default_1.targets = ["starContainer", "starRating"];
